module.exports = __webpack_public_path__ + "img/ally-zimmerman.33c7b5d3.jpg";